// extracted by mini-css-extract-plugin
export default {"card-data-container":"card_card-data-container__LI01a","card":"card_card__w6IZB"};